import React, { useState } from "react";
import "./Profile.css";
import ModuleSidebar from "../../components/ModuleSidebar/ModuleSidebar";
import { GoPeople } from "react-icons/go";
import { useLanguage } from "../../LanguageProvider";
import ProfileInformation from "./ProfileInformation/ProfileInformation";
import UpdatePassword from "./UpdatePassword/UpdatePassword";

export default function Profile() {
  const { getTranslation } = useLanguage();
  const [selectedSubmenuId, setSelectedSubmenuId] = useState(1);

  const menus = [
    {
      sections: [
        {
          title: getTranslation("profile"),
          icon: <GoPeople size={20} />,
          submenu: [
            { title: getTranslation("profileInfo"), id: 1 },
            { title: getTranslation("changePassword"), id: 2 },
          ],
        },
      ],
    },
  ];

  const handleSubmenuClick = (submenu) => {
    setSelectedSubmenuId(submenu.id);
  };

  return (
    <div className="profile-container">
      <ModuleSidebar
        title={getTranslation("profile")}
        menus={menus}
        selectedSubmenu={selectedSubmenuId}
        onSubmenuClick={handleSubmenuClick}
      />
      <div className="profile-content">
        <div className="profile-inner-content">
          {selectedSubmenuId === 1 && <ProfileInformation />}
          {selectedSubmenuId === 2 && <UpdatePassword />}
        </div>
      </div>
    </div>
  );
}
